/** Pill chrome shared by rent-paid status badges on the residents list. */
export const RENT_PAID_BADGE_BASE =
  'inline-flex w-max max-w-none shrink-0 items-center justify-center whitespace-nowrap rounded-full border border-solid box-border px-3 py-1 text-xs font-semibold leading-none'

/**
 * Per-status badge tones — matches the listing screenshot: Paid in Full (green),
 * Not Paid in Full (amber), Not updated (grey), everything else a neutral outline.
 */
export const RENT_PAID_BADGE_TONES = {
  paid: 'border-[#34a853] bg-[#e6f4ea] text-[#1e7e34]',
  notPaid: 'border-[#ff9800] bg-[#fff4e5] text-[#c87000]',
  notUpdated: 'border-transparent bg-[#f1f3f4] text-[#5f6368]',
  /** Activation / policy workflow and legacy statuses — neutral outline badge. */
  neutral: 'border-slate-300 bg-slate-50 text-slate-700',
} as const
